import { render, staticRenderFns } from "./Termos.vue?vue&type=template&id=6a94e0a0&scoped=true"
import script from "./Termos.vue?vue&type=script&lang=js"
export * from "./Termos.vue?vue&type=script&lang=js"
import style0 from "./Termos.vue?vue&type=style&index=0&id=6a94e0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a94e0a0",
  null
  
)

export default component.exports